import React from 'react';

interface IconSaturationProps {
    width?: number | string;
    height?: number | string;
    color?: string;
}

const IconSaturation: React.FC<IconSaturationProps> = ({
    width = 17,
    height = 17,
    color = 'black',
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 17 17"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.63228 1.54122C9.63143 1.54037 9.63075 1.53969 9.63007 1.53884C9.33308 1.23437 8.92593 1.0625 8.50076 1.0625C8.07542 1.06233 7.6681 1.23386 7.37111 1.53833C7.37026 1.53918 7.36941 1.54003 7.36856 1.54088C5.96844 2.99557 3.18945 7.31085 3.18945 10.6306C3.18945 13.5594 5.56911 15.9373 8.50059 15.9373C11.4321 15.9373 13.8119 13.5594 13.8119 10.6306C13.8119 7.31085 11.0329 2.9954 9.63228 1.54122ZM12.5485 9.03108H4.45289C5.0858 6.32009 7.05967 3.39473 8.13271 2.27919C8.22961 2.18059 8.36204 2.12483 8.50042 2.125C8.6388 2.125 8.7714 2.18076 8.8683 2.27953C9.94151 3.39456 11.9156 6.32009 12.5485 9.03108Z"
            fill={color}
        />
    </svg>
);

export default IconSaturation;
